import React from 'react';
import PropTypes from 'prop-types';
import FormField from './FormField';
import QuickUpdatableComponent from './QuickUpdatableComponent';

class TextArea extends QuickUpdatableComponent {
    render() {
        const {field, help, options, label, disabled, loading, rows, required, forceFullSize = false, autoRows = true} = this.props;
        let rowCount = rows || 2;
        if (autoRows) {
            rowCount = Math.max(field.value && field.value.split("\n").length, rowCount);
        }

        return (
            <FormField required={required} field={field} help={help} loading={loading} label={label} forceFullSize={forceFullSize}>
                <textarea
                    {...field}
                    rows={rowCount}
                    className="form-control"
                    disabled={disabled}
                    id={field.name}
                    value={field.value} ></textarea>
                <div className="br" />
            </FormField>);
    }
}

TextArea.propTypes = {
    field: PropTypes.object.isRequired,
    text: PropTypes.string,
}

export default TextArea;
